export const textEllipsis = (str, maxLength) => {
  const ellipsis = "..."
  if (str.length > maxLength) {
    return str.slice(0, maxLength - ellipsis.length) + ellipsis;
  }
  return str;
}